import moment from "moment";

export default function calculatePassedTime(date: string) {
	const now = moment();
	const dateInLocal = moment.utc(date).local(); // Convert UTC to local timezone
	
	// Subtract 7 hours from the date
	const adjustedDate = dateInLocal.subtract(7, 'hours');

	// if date pass then 1 day then return date, if not then return time
	if (now.diff(adjustedDate, "days") > 1) {
		return adjustedDate.format("DD/MM/YYYY");
	}
	return adjustedDate.format("HH:mm");
}